export default (F) => ({
  actions: F.create({
    header: { content: 'Actions' },
    item: {
      key: 'actions',
      slot: 'actions',
      sortable: false,
      total: null,
      display: false,
    },
  }),
  title: F.create({
    header: { content: 'Creative Preview' },
    item: {
      key: 'title',
      slot: 'creative_preview',
      content: (item) => (item.headline.trim().length ? item.headline.trim() : item.traffic_source_item_id),
      sortable: true,
      total: {
        content: (totals) => `Total: ${totals.totalElements}`,
      },
    },
  }),
});
